/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './instance.reducer';

export const InstanceDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const instanceEntity = useAppSelector(state => state.instance.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="instanceDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.instance.detail.title">Instance</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.instance.id">Id</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.id}</dd>
          <dt>
            <span id="sopInstanceUid">
              <Translate contentKey="tinyMedicRestApp.instance.sopInstanceUid">Sop Instance Uid</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.sopInstanceUid}</dd>
          <dt>
            <span id="instanceNumber">
              <Translate contentKey="tinyMedicRestApp.instance.instanceNumber">Instance Number</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.instanceNumber}</dd>
          <dt>
            <span id="sopClassUid">
              <Translate contentKey="tinyMedicRestApp.instance.sopClassUid">Sop Class Uid</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.sopClassUid}</dd>
          <dt>
            <span id="patientOrientation">
              <Translate contentKey="tinyMedicRestApp.instance.patientOrientation">Patient Orientation</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.patientOrientation}</dd>
          <dt>
            <span id="mediaStorageSopInstanceUid">
              <Translate contentKey="tinyMedicRestApp.instance.mediaStorageSopInstanceUid">Media Storage Sop Instance Uid</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.mediaStorageSopInstanceUid}</dd>
          <dt>
            <span id="transferSyntaxUid">
              <Translate contentKey="tinyMedicRestApp.instance.transferSyntaxUid">Transfer Syntax Uid</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.transferSyntaxUid}</dd>
          <dt>
            <span id="acquisitionDateTime">
              <Translate contentKey="tinyMedicRestApp.instance.acquisitionDateTime">Acquisition Date Time</Translate>
            </span>
          </dt>
          <dd>
            {instanceEntity.acquisitionDateTime ? (
              <TextFormat value={instanceEntity.acquisitionDateTime} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="imageType">
              <Translate contentKey="tinyMedicRestApp.instance.imageType">Image Type</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.imageType}</dd>
          <dt>
            <span id="pixelSpacing">
              <Translate contentKey="tinyMedicRestApp.instance.pixelSpacing">Pixel Spacing</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.pixelSpacing}</dd>
          <dt>
            <span id="imageOrientation">
              <Translate contentKey="tinyMedicRestApp.instance.imageOrientation">Image Orientation</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.imageOrientation}</dd>
          <dt>
            <span id="imagePosition">
              <Translate contentKey="tinyMedicRestApp.instance.imagePosition">Image Position</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.imagePosition}</dd>
          <dt>
            <span id="sliceThickness">
              <Translate contentKey="tinyMedicRestApp.instance.sliceThickness">Slice Thickness</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.sliceThickness}</dd>
          <dt>
            <span id="sliceLocation">
              <Translate contentKey="tinyMedicRestApp.instance.sliceLocation">Slice Location</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.sliceLocation}</dd>
          <dt>
            <span id="windowCenter">
              <Translate contentKey="tinyMedicRestApp.instance.windowCenter">Window Center</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.windowCenter}</dd>
          <dt>
            <span id="windowWidth">
              <Translate contentKey="tinyMedicRestApp.instance.windowWidth">Window Width</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.windowWidth}</dd>
          <dt>
            <span id="xrayTubeCurrent">
              <Translate contentKey="tinyMedicRestApp.instance.xrayTubeCurrent">Xray Tube Current</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.xrayTubeCurrent}</dd>
          <dt>
            <span id="exposureTime">
              <Translate contentKey="tinyMedicRestApp.instance.exposureTime">Exposure Time</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.exposureTime}</dd>
          <dt>
            <span id="kvp">
              <Translate contentKey="tinyMedicRestApp.instance.kvp">Kvp</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.kvp}</dd>
          <dt>
            <span id="contentDateTime">
              <Translate contentKey="tinyMedicRestApp.instance.contentDateTime">Content Date Time</Translate>
            </span>
          </dt>
          <dd>
            {instanceEntity.contentDateTime ? (
              <TextFormat value={instanceEntity.contentDateTime} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="columns">
              <Translate contentKey="tinyMedicRestApp.instance.columns">Columns</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.columns}</dd>
          <dt>
            <span id="rows">
              <Translate contentKey="tinyMedicRestApp.instance.rows">Rows</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.rows}</dd>
          <dt>
            <span id="photometricInterpretation">
              <Translate contentKey="tinyMedicRestApp.instance.photometricInterpretation">Photometric Interpretation</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.photometricInterpretation}</dd>
          <dt>
            <span id="bitsAllocated">
              <Translate contentKey="tinyMedicRestApp.instance.bitsAllocated">Bits Allocated</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.bitsAllocated}</dd>
          <dt>
            <span id="bitsStored">
              <Translate contentKey="tinyMedicRestApp.instance.bitsStored">Bits Stored</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.bitsStored}</dd>
          <dt>
            <span id="pixelRepresentation">
              <Translate contentKey="tinyMedicRestApp.instance.pixelRepresentation">Pixel Representation</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.pixelRepresentation}</dd>
          <dt>
            <span id="highBit">
              <Translate contentKey="tinyMedicRestApp.instance.highBit">High Bit</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.highBit}</dd>
          <dt>
            <span id="imageOrientationPatient">
              <Translate contentKey="tinyMedicRestApp.instance.imageOrientationPatient">Image Orientation Patient</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.imageOrientationPatient}</dd>
          <dt>
            <span id="imagePositionPatient">
              <Translate contentKey="tinyMedicRestApp.instance.imagePositionPatient">Image Position Patient</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.imagePositionPatient}</dd>
          <dt>
            <span id="frameOfReferenceUid">
              <Translate contentKey="tinyMedicRestApp.instance.frameOfReferenceUid">Frame Of Reference Uid</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.frameOfReferenceUid}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.instance.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.instance.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.instance.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.instance.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.instance.active">Active</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="imageObservation">
              <Translate contentKey="tinyMedicRestApp.instance.imageObservation">Image Observation</Translate>
            </span>
          </dt>
          <dd>{instanceEntity.imageObservation}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.instance.series">Series</Translate>
          </dt>
          <dd>{instanceEntity.series ? instanceEntity.series.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/instance" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/instance/${instanceEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InstanceDetail;
